import { colors, size } from '@styles/theme'
import { TbCircle, TbCircleFilled, TbTarget } from 'react-icons/tb'

const indicatorStyles = {
  alignSelf: 'flex-start',
  marginTop: size(0.35),
  marginLeft: size(0.35),
}

const NearbyActiveIndicator = ({ isActive }) => {
  if (isActive) {
    return (
      <TbCircleFilled
        style={indicatorStyles}
        size={size(0.75)}
        color={colors.statusColors['right_now']('light')}
      />
    )
  }

  return (
    <TbCircle
      style={{ visibility: 'hidden' }}
      size={size(0.75)}
      color='rgba(255,255,255,0.25)'
      strokeWidth={size(0.25)}
    />
  )
}

export { NearbyActiveIndicator }
